import { render, staticRenderFns } from "./packageDetails.vue?vue&type=template&id=255c81be&scoped=true"
import script from "./packageDetails.vue?vue&type=script&lang=js"
export * from "./packageDetails.vue?vue&type=script&lang=js"
import style0 from "./packageDetails.vue?vue&type=style&index=0&id=255c81be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255c81be",
  null
  
)

export default component.exports